/* eslint no-undef: 'off' */
/* eslint no-console: 'off' */
import $ from "jquery";
import Swiper from 'swiper/bundle';
import "fslightbox"


const bookingSingleProductGalleries = () => {
    const target = ".wb-SingleProduct";
    const $target = $(target);

    const init = () => {
        if ($target.length) {
            exec();
        }
    };

    const exec = () => {
        const galleriesThumbs = new Swiper('.galleriesThumbs', {
            spaceBetween: 10,
            slidesPerView: 2,
            freeMode: true,
            watchSlidesVisibility: true,
            watchSlidesProgress: true,
            pagination: {
                el: '.galleriesThumbsPagination',
                clickable: true, 
            },
            breakpoints: {
                600: {
                    slidesPerView: 3, 
                },
            },
        });
        // eslint-disable-next-line
        const galleriesMain = new Swiper('.galleriesMain', {
            spaceBetween: 10,
            thumbs: {
                swiper: galleriesThumbs,
            },
        });
    };
    
    init();
};

try {
    bookingSingleProductGalleries();
} catch (error) {
    throw Error(error);
}
